import { ProductHeading } from '@issuu/silkscreen';
import React, { useContext } from 'react';

import DocumentContext from '../DocumentPage/DocumentContext';
import { TextOverflow } from '../shared/styles';

export const Title: React.FC = () => {
    const {
        document: { title },
    } = useContext(DocumentContext);
    return (
        <TextOverflow>
            <ProductHeading
                data-testid="document-title"
                itemProp="name"
                level={3}
                step="negative-1"
            >
                {title}
            </ProductHeading>
        </TextOverflow>
    );
};
